import {MODULE_GRUPPI} from "../../../const/ModuliConstants";

export const SMART_PACKAGES_MODULES_TYPE = {
    [MODULE_GRUPPI]: "mod_gruppi",
}


export const DISABLED_WALLET_ORDER_NOT_COMPLETE = "disabled_wallet_order_not_complete";
export const DISABLED_WALLET_NOT_AVAILABLE_IN_WEEKDAY = "disabled_wallet_not_available_in_weekday";